var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"overlay"}),_c('LeftSidebar'),_c('section',{staticClass:"content"},[_c('div',{staticClass:"body_scroll"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1),_c('Language')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }